import type { SVGProps } from 'react';

export const WarningInverse = (props: SVGProps<SVGSVGElement>) => (
    <svg width='18' height='18' fill='currentColor' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg' {...props}>
        <circle cx='9' cy='9' r='8' stroke='#fff' />
        <path fill='#fff' d='M8 5h2v5H8zM8 11h2v2H8z' />
    </svg>
);
